import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <AppSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <TopicsSection />
        <FeaturesSection />
        <AboutSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}